import { observer } from 'mobx-react-lite'
import { type JobProgressionViewModel } from '@/features/jobs/details/components/JobProgressionCard/JobProgressionViewModel'
import { WaitingOnClientProgressionActions } from '@/features/jobs/details/components/JobProgressionCard/WaitingOnClientProgressionActions'

export interface WaitingOnClientProgressionActionsContainerProps {
  vm: JobProgressionViewModel
}

export const WaitingOnClientProgressionActionsContainer = observer(
  function WaitingOnClientProgressionActionsContainer({
    vm,
  }: WaitingOnClientProgressionActionsContainerProps) {
    return (
      <WaitingOnClientProgressionActions
        isOutsourcingExtension={vm.isOutsourcingExtension}
        onReadyToFile={() => vm.answerReadyToFile(false)}
      />
    )
  },
)
